import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { updateOnboarding } from '../../clients/onboardingClient';
import type { Step, StepRuntime } from '../types/types';
import { StepSlug } from '../types/types';

function IndustryStep({ next, saveStep }: StepRuntime): JSX.Element {
  const [selected, setSelected] = useState<string | null>(null);

  const options = [
    'Social Services',
    'Healthcare',
    'Finance',
    'Education',
    'Legal',
    'Research',
    'Nonprofit',
    'Operations',
    'Other'
  ];

  const onboardingMutation = useMutation({
    mutationFn: updateOnboarding,
    onSettled: () => {
      if (selected) {
        saveStep(StepSlug.Industry, selected);
        // Add a small delay before advancing to the next page
        setTimeout(() => {
          next(StepSlug.Role);
        }, 200); // 0.20 second delay
      }
    }
  });

  function submit(industry: string) {
    // Calculate progress based on current step (Industry is step 1 of 4)
    const progress = 0;

    onboardingMutation.mutate({
      sector: industry,
      role: 'Other',
      progress
    });
  }

  function handleSelection(option: string) {
    setSelected(option);
    // Automatically submit when an option is selected
    submit(option);
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-6 relative bg-[url('./images/grid.png')] bg-repeat bg-[length:500px]">
      <div className="absolute top-1/4 w-full text-center">
        <h2 className="text-lg font-medium text-indigo-800/60">
          Let's tailor <span className="text-indigo-800">Notewell</span> to your needs ✏️
        </h2>
      </div>

      <div className="max-w-2xl text-center">
        <h1 className="text-3xl font-semibold text-gray-900 mb-10">
          What industry do you work in?
        </h1>

        <div className="flex flex-wrap justify-center gap-x-3 gap-y-4">
          {options.map((option) => (
            <button
              key={option}
              onClick={() => handleSelection(option)}
              className={`px-5 py-2 rounded-full border font-medium text-base transition-colors duration-300
                ${
                  selected === option
                    ? 'bg-indigo-600 text-white border-indigo-600'
                    : 'bg-indigo-50 text-indigo-700 border-indigo-300 hover:border-indigo-700 hover:text-indigo-600 hover:bg-indigo-200'
                }`}
            >
              {option}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export const IndustryStepModule: Step = {
  slug: StepSlug.Industry,
  title: 'Industry',
  Component: IndustryStep
};
